<section translate="no">
    <main>
    <section class="pesq-section div_orientacao">

      <form class="form-class" data-toggle="collapse" (ngSubmit)="MudaFiltro()">
        <div class="div_busca_orientacao">
          

          @if(validarRole() == true){
          <div class="btnplus"  [ngClass]="{'subeButtonAdd': subeButtonAdd}"  style="position: fixed; bottom: 13px; right: 22px;">
            <a [routerLink]="['/parametro-header-adicionar']" [queryParams]="{IdNovo: obterMaiorCodigo()}"><button id="class-button"
                style="border-radius: 50%;width: 45px;height: 45px;" class="btn btn-success"><i
                  class="fas fa-plus"></i></button></a>
          </div>
          }

        </div>
      </form>

    </section>
    <!--Tabela -->
    <section class="main-section-table">
      <div class="tabela-wrapper">
      <table class="table">
        <!--toJsonBody-->
        <thead>

          <tr>
            <th scope="col">Codigo</th>
            <th scope="col">Sistema</th>
            <th scope="col">Width</th>
            <th scope="col">Height</th>
            <th scope="col">ALT</th>
            <th scope="col">Tipo</th>
            <th scope="col">Periodo Eleitoral</th>
            <th scope="col">Ativo</th>
            <th scope="col">Nome</th>
            @if(validarRole() == true){
            <th scope="col">Funções</th>
            }
          </tr>
        </thead>
        <tbody>
          @for (p of listaOrg; track $index) {
          <tr>
            <td style="font-weight: bold;">{{p.id}}</td>
            <td>{{p.sistema}}</td>
            <td>{{p.width}}</td>
            <td>{{p.height}}</td>
            <td>{{p.alt}}</td>
            <td>{{p.tipo}}</td>
            <td>{{p.periodoEleitoral}}</td>
            <td>{{p.ativo}}</td>
            <td>{{p.nome}}</td>
            @if(sistemaCheck(p.sistema) == true){
            @if(validarRole() == true){
            <td><a class="btn btn-primary" style="margin-right: 10px;" [routerLink]="['/parametro-header-adicionar']"
                [queryParams]="{IdEditar: p.id}">Editar</a>
              <button class="btn btn-danger" (click)="excluirItem(p.id)">Excluir</button>
              @if(validarRoleSuper() == true){
              <a [routerLink]="['/auditoria-listagem']"
                [queryParams]="{id: p.id, tabela: 'Parametro Header'}"><button class="btn btn-secondary"
                  style="margin-left: 10px;"><i class="fas fa-history"></i></button></a>
              }
            </td>
            }
          }


          </tr>
          }
        </tbody>
      </table>
    </div>

      <mat-paginator #paginator class="demo-paginator" (page)="handlePageEvent($event)" [length]="totalPages"
        [pageSize]="pageSize" [disabled]="disabled" [showFirstLastButtons]="showFirstLastButtons"
        [pageSizeOptions]="[5, 10, 25, 100]" [hidePageSize]="true" [pageIndex]="pageIndex" aria-label="Select page">
      </mat-paginator>
    </section>


  </main>
  <div style="height: 150px;">
  </div>
</section>